export default "__VITE_ASSET__bq2NT18g__"